import { useEffect } from 'react';

import { observer } from 'mobx-react';

import { useVisibility } from '../../hooks/useVisibility';
import { SEARCH_CATEGORY_ID } from '../../stores/categories/CategoriesStore';
import { useStores } from '../../stores/useStores';

const MoreGames = observer(() => {
  const { categoriesStore, gamesSearchStore } = useStores();
  const { ref, visible } = useVisibility<HTMLDivElement>();

  useEffect(() => {
    if (visible && categoriesStore.currentCategory?.hasMoreGames) {
      if (categoriesStore.currentCategory.masterGameSubCategoryId === SEARCH_CATEGORY_ID) {
        void categoriesStore.getNextSearchGames(
          'pagination',
          gamesSearchStore.searchTerm,
          gamesSearchStore.searchGamesLimit,
        );
      } else {
        void categoriesStore.getNextGames();
      }
    }
  }, [categoriesStore, gamesSearchStore, categoriesStore.currentCategory?.hasMoreGames, visible]);

  return <div ref={ref} />;
});

export default MoreGames;
